import { render, staticRenderFns } from "./FootLogo.vue?vue&type=template&id=ac25e2de"
var script = {}
import style0 from "./FootLogo.vue?vue&type=style&index=0&id=ac25e2de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports